import { type FunctionComponent } from 'react';

import { Icon } from '@kanda-libs/ks-design-library';

import Modal from './Modal';
import useOmniSignDocumentsMobileButton from './useOmniSignDocumentsMobileButton';

const OmniSignDocumentsMobileButton: FunctionComponent = () => {
  const { onClick } = useOmniSignDocumentsMobileButton();
  return (
    <div className="w-full">
      <p className="text-14-22-em text-neutral-700 mb-3">To do:</p>
      <button
        onClick={onClick}
        type="button"
        className="flex flex-row w-full p-3 justify-between border border-neutral-300 shadow-card rounded-xl"
      >
        <div className="flex flex-row">
          <div className="rounded-full p-1 bg-lavender-200 mb-auto mt-1.5 mr-2" />
          <div className="flex flex-col text-left">
            <p className="text-14-22-em text-lavender-300">
              Sign your credit contracts
            </p>
            <p className="text-12-18 text-neutral-600">
              Please review and sign the agreements
            </p>
          </div>
        </div>
        <Icon
          icon="chevron-right"
          size={16}
          className="my-auto ml-3"
          stroke="neutral-600"
        />
      </button>
      <Modal />
    </div>
  );
};

export default OmniSignDocumentsMobileButton;
